// @flow

type Params = {|
    offsetWidth: Array<number>,
    cellStartIndex: number,
    cellEndIndex: number,
    viewportWidth: number,
    offset: number,
|};

const CELL_INDEX_OFFSET = 1;

export const shouldUpdateOnScroll = (param: Params): boolean => {
    const {offsetWidth, cellStartIndex, cellEndIndex, viewportWidth, offset} = param;
    const SCROLL_LEFT_UPDATES = offsetWidth[cellStartIndex + CELL_INDEX_OFFSET] >= offset;
    const SCROLL_RIGHT_UPDATES = (offsetWidth[cellEndIndex] || 0) - viewportWidth <= offset;

    return SCROLL_LEFT_UPDATES || SCROLL_RIGHT_UPDATES;
};
